import useLanguage from '../hooks/useLanguage';
import styles from '../assets/styles/Solution.module.css';
import { translations } from '../locales/lang';

export default function SolutionsSection() {
    const { language } = useLanguage();

    const solutions = [
        {
            id: 1,
            label: translations[language].solution.admin.title,
            image: '/images/solution/admin.jpg',
            gradient: styles.adminGradient,
            content: translations[language].solution.admin.content
        },
        {
            id: 2,
            label: translations[language].solution.teacher.title,
            image: '/images/solution/teacher.jpg',
            gradient: styles.teacherGradient,
            content: translations[language].solution.teacher.content
        },
        {
            id: 3,
            label: translations[language].solution.student.title,
            image: '/images/solution/student.jpg',
            gradient: styles.studentGradient,
            content: translations[language].solution.student.content
        },
        {
            id: 4,
            label: translations[language].solution.parent.title,
            image: '/images/solution/parent.jpg',
            gradient: styles.parentGradient,
            content: translations[language].solution.parent.content
        },
    ];

    return (
        <section className={styles.section} id='solution'>
            <h2 className={styles.title} dangerouslySetInnerHTML={{ __html: translations[language].solution.title }} />
            <div className={styles.cardContainer}>
                {solutions.map((item) => (
                    <div
                        key={item.id}
                        data-aos={'fade-left'}
                        data-aos-delay={item.id * 100}
                        className={`${styles.card} ${item.gradient}`}
                    >
                        <img src={`${item.image}`} alt={`${item.label}`} style={{ position: 'absolute' }} />
                        <span className={styles.label}>{item.label}</span>
                        <div className={styles.overlay} >
                            <ul className={styles.content}>
                                {item.content.map((line, i) => (
                                    <li key={i}>{line}</li>
                                ))}
                            </ul>
                        </div>
                    </div>
                ))
                }
            </div >
        </section >
    );
}
